import { Auth } from '@aws-amplify/auth';

import { activeTenant } from '@app/tenant';
import { readTenantEnv } from '@app/tenant/env';

// D7: `activeTenant` is `null` on an unknown hostname / failed env validation, in which case
// `Auth.configure` receives `undefined` ids — inert, because the neutral screen (`index.tsx`)
// never renders anything that touches Cognito. D7's boot-time validation already ran (`@app/tenant`
// module evaluation) before this module runs, so a *resolved* tenant is never missing these.
Auth.configure({
  userPoolId: activeTenant ? readTenantEnv(activeTenant.slug, 'COGNITO_USER_POOL_ID') : undefined,
  userPoolWebClientId: activeTenant ? readTenantEnv(activeTenant.slug, 'COGNITO_USER_POOL_WEB_ID') : undefined,
});

const cognitoClient = Auth;

export { cognitoClient };
